// src/app/app.component.ts
import { Component } from '@angular/core';
//import { RouterOutlet } from '@angular/router';
import { JobSidePreviewComponent } from "./Modules/Job/Components/job-side-preview/job-side-preview.component";
import { PageHeaderComponent } from "./page-header/page-header.component";
import { JobDetailsComponent } from "./Modules/Job/Components/job-details/job-details.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ JobSidePreviewComponent, JobDetailsComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
 partnerId!: string;
 siteId!: string;

  constructor() {
    // Add this inside the constructor so it runs when the app boots
    if (!window.appScope) window.appScope = {};

    // 1. Create a global flag to know if we've already started loading it
    let isJobDetailsLoading = false;

    // 2. Define the global stub
    window.appScope.jobTitle = (scope: any, launchJobDetailsOnLoad: any, currentElem_id: any) => {
      
      const jobDetailsElement = document.querySelector('app-job-details');

      // If the component is ALREADY on the page, the real function inside ngOnInit 
      // would have already overwritten this stub. But just in case, we do nothing if it exists.
      if (!jobDetailsElement && !isJobDetailsLoading) {
        isJobDetailsLoading = true;
        console.log('Dynamically injecting <app-job-details> into the DOM...');
        
        // Create the element and add it to the body (or a specific container)
        const newElement = document.createElement('app-job-details');
        document.body.appendChild(newElement);

        // Wait a brief moment for Angular to initialize the component and run its ngOnInit.
        // When its ngOnInit runs, it will OVERWRITE window.appScope.jobTitle with the real function!
        setTimeout(() => {
          isJobDetailsLoading = false;
          
          // Now that the real function is registered, we can call it!
          if (typeof window.appScope.jobTitle === 'function') {
            window.appScope.jobTitle(scope, launchJobDetailsOnLoad, currentElem_id);
          }
        }, 150); // 150ms is usually enough for Angular to compile and mount the element
      }
    };
  }

 }
